<template>
  <div>
    <Header></Header>
    <div class="container">
      <div class="nav"><a href="/login">登录</a> > <span>忘记密码</span></div>
      <div class="form-container">
        <el-input type="text" v-model="phone" placeholder="请输入注册的手机号"></el-input>
        <p></p>
        <el-button type="primary" class="ex-btn" @click="submitForm()"
          >确认</el-button
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
.container {
  width: 980px;
  height: 400px;
  margin: 0 auto;
  margin-top:16px;
}
.form-container {
  width: 480px;
  margin: 0 auto;
}
.nav{margin-bottom: 16px;}
a {
  font-size: 13px;
  font-weight: bold;
}
.ex-btn {
  width: 100%;
}
</style>
<script>
import Header from "./headernew.vue";
export default {
  components: {
    Header,
  },
  data(){
      return{
          phone:""
      }
  },
  methods:{
      submitForm(){
          if(this.phone!="" && this.phone!=undefined){
              this.$http.get("/api/password?phone="+this.phone).then(res=>{
                  if(res.data==200){
                      this.$router.push({name:'pset',params:{phone:this.phone}});
                  }
              });
          }
      }
  }
};
</script>

